import {createElement, Component, PropTypes, isValidElement} from 'rlink-react';
import {escapeHTML} from 'rlink-utils/string';

const DOM_ELEMENT_REFS = new Map();

export default class DocumentComponent extends Component {
  constructor (...args) {
    super(...args);
    this.domElement = null;
    this.domAttributeCache = {};
    this.domInnerTextCache = null;
  }

  componentWillMount () {
    if (this.context.serverRenderingDocument) {
      this.context.serverRenderingDocument.registerMountedInstance(this);
    }
  }

  formatMessage (message) {
    if (typeof message === 'object') {
      let props = isValidElement(message)
        ? [message.props, message.props.values]
        : message;

      return this.props.intl.formatMessage(...props);
    } else {
      return message;
    }
  }

  get attributes () {
    return {};
  }

  componentDidMount () {
    let element = document.querySelector(this.selector);

    if (element) {
      let component = this.constructor.forDomElement(element);

      if (component && component !== this) {
        console.warn(`Multiple ${this.constructor.name} instances are controlling ${element}!`);
      }

      for (let name of Object.keys(this.attributes)) {
        this.domAttributeCache[name] = element.getAttribute(name);
      }

      this.domInnerTextCache = element.innerText;
      this.domElement = element;
    } else {
      this.domElement = this.createDomElement();
      this.constructor.insertDomElement(this.documentSlot, this.domElement);
    }

    DOM_ELEMENT_REFS.set(this.domElement, this);
  }

  componentDidUpdate () {
    this.updateDomElement(this.domElement);
  }

  componentWillUnmount () {
    let component = this.constructor.forDomElement(this.domElement);

    if (component && component === this) {
      DOM_ELEMENT_REFS.delete(this.domElement);

      if (this.domElement.parentNode) {
        this.domElement.parentNode.removeChild(this.domElement);
      }
    }
  }

  createDomElement () {
    if (this.domElement) {
      throw new Error(`Cannot create a new dom element when ${this} is already assigned to one!`);
    }
    this.domElement = document.createElement(this.tagName);
    this.updateDomElement();
    return this.domElement;
  }

  updateDomElement () {
    for (let [name, value] of Object.entries(this.attributes)) {
      if (this.domAttributeCache[name] !== value) {
        this.domElement.setAttribute(name, value);
        this.domAttributeCache[name] = value;
      }
    }
    if (this.innerText && this.innerText !== this.domInnerTextCache) {
      this.domElement.innerText = this.innerText;
      this.domInnerTextCache = this.innerText;
    }
    return this.domElement;
  }

  get keyAttributes () {
    let attributes = {};
    for (let attribName of this.keyAttributeNames) {
      attributes[attribName] = this.attributes[attribName];
    }
    return attributes;
  }

  get mountKey () {
    return this.selector;
  }

  get selector () {
    return `${this.tagName}${this.constructor.toAttributeSelectors(this.keyAttributes)}`;
  }

  toString () {
    if (this.innerText) {
      return `<${this.tagName}${this.constructor.toAttributeString(this.attributes)}>${this.innerText}</${this.tagName}>`;
    } else {
      return `<${this.tagName}${this.constructor.toAttributeString(this.attributes)} />`;
    }
  }

  static insertDomElement (slot, element) {
    switch (slot) {
      case 'head':
        document.head.appendChild(element);
        break;
      case 'bodyTop':
        document.body.childNodes[0] ? document.body.insertBefore(parent, document.body.childNodes[0]) : document.body.appendChild(element);
        break;
      case 'bodyBottom':
        document.body.appendChild(element);
        break;
      default:
        throw new Error(`Unknown document slot: ${slot}`);
    }
  }

  static forDomElement (element) {
    return element && DOM_ELEMENT_REFS.get(element);
  }

  static toAttributeString (attributes) {
    //@TODO remove String casting, add explicit check for string instead
    return ` ${Object.entries(attributes).map(([name, value]) => `${name}="${escapeHTML(String(value))}"`).join(' ')}`;
  }

  static toAttributeSelectors (attributes) {
    return Object.entries(attributes).map(([name, value]) => `[${name}="${escapeHTML(String(value))}"]`).join(' ');
  }

  render () {
    return null;
  }
}
DocumentComponent.contextTypes = {
  // serverRenderingDocument: PropTypes.instanceOf(ServerRenderingDocument),
  serverRenderingDocument: PropTypes.object,
};

DocumentComponent.propTypes = {
  intl: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./lib/rlink-react-document/DocumentComponent.jsx